<template>
	<div class="key-students">
		<div class="key-students-cont">
			<div class="keyStudents-title">
				<span>重点学生</span>
			</div>
			<div class="topTen-desc" v-if="haveData == 1">
				<span>本次考试排名前十的学生：</span>
			</div>
			<div class="topten-table" v-if="haveData == 1">
				<tables :tableOptions="examinationStudentsData"></tables>
			</div>
			<div class="topTen-desc">
				<span>本次考试本校排名前十的学生：</span>
			</div>
			<div class="topten-table">
				<tables :tableOptions="topTenGradeData"></tables>
			</div>
			<div style="height: 20px"></div>
			<div class="lastten-desc">
				<span>本次考试本校排名后十的学生：</span>
			</div>
			<div class="lastten-table">
				<tables :tableOptions="lastTenGradeData"></tables>
			</div>
			<div class="excellent-students">
				<div class="excestu-title">
					<div class="excestu-title-cont">
						<span style="font-size: 17px; font-weight: bold">优秀学生人数班级分布：</span>
						<!-- <div class="Ranking-rate">
							<el-button type="" :class="RankFlag1 ? 'current' : ''" size="mini" @click="exceRankClick">名次</el-button>
							<el-button type="" :class="RankFlag2 ? 'current' : ''" size="mini" @click="exceRateClick">比例</el-button>
						</div> -->
						<!-- <div class="top-grade">
							<span>年级前</span>
							<el-input type="text" v-model="exceRanking" size="mini" @input="ExceRankingInpt"></el-input>
							<span>{{ exceDesc }}</span>
						</div> -->
					</div>
					<!-- <div>
						<el-button type="info" size="mini" :disabled="flag" @click="exceGradeStatistics">统计</el-button>
					</div> -->
				</div>
				<div style="margin-bottom: 20px" v-for="(item, index) in excellSudentsData" :key="index">
					<div style="margin-bottom: 15px; font-weight: bold">
						<span>按{{ item.level }}分析：</span>
						<span>年级前{{ item.exceRanking }}名</span>
					</div>
					<div class="excestu-table">
						<tables :tableOptions="item.goodStudentsData"></tables>
					</div>
				</div>
			</div>
			<div class="improved-students">
				<div class="excestu-title">
					<div class="excestu-title-cont">
						<span style="font-size: 17px; font-weight: bold">待提高学生人数班级分布：</span>
						<!-- <div class="Ranking-rate">
							<el-button type="" :class="improRankFlag1 ? 'current' : ''" size="mini" @click="ImproRankClick">名次</el-button>
							<el-button type="" :class="improRankFlag2 ? 'current' : ''" size="mini" @click="ImproRateClick">比例</el-button>
						</div> -->
						<!-- <div class="top-grade">
							<span>年级后</span>
							<el-input v-model="improveRanking" size="mini" @input="improveRankingInpt"></el-input>
							<span>{{ improDesc }}</span>
						</div> -->
					</div>
					<div>
						<!-- <el-button type="info" size="mini" :disabled="newflag" @click="improveGradeStatistics">统计</el-button> -->
					</div>
				</div>
				<div style="margin-bottom: 20px" v-for="(item, index) in ImproveStudentsDataArr" :key="index">
					<div style="margin-bottom: 15px; font-weight: bold">
						<span>按{{ item.level }}分析：</span>
						<span>年级后{{ item.improveRanking }}名</span>
					</div>
					<div class="excestu-table">
						<tables :tableOptions="item.improveStudentsData"></tables>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	// name: 'test',
	components: {
		tables: () => import('hm-table')
	},
	data() {
		return {
			newTableData: [
				{
					// class: '班级',
					class: '1班',
					subject: [
						{
							name: '语文',
							children: [
								{
									name: '平均分',
									code: '12'
								},
								{
									name: '平均分1',
									code: '12'
								}
							]
						},
						{
							name: '数学',
							children: [
								{
									name: '平均分',
									code: '12'
								}
							]
						}
					]
				},

				{
					stet2: '666',
					class: '2班',

					subject: [
						{
							name: '语文',
							children: [
								{
									name: '平均分',
									code: '13'
								},
								{
									name: '平均分1',
									code: '13'
								}
							]
						},
						{
							name: '数学',
							children: [
								{
									name: '平均分',
									code: '13'
								},
								{
									name: '平均分1',
									code: '13'
								}
							]
						}
					]
				}
			],
			input: '',
			stuData: [
				{
					name: '杨一',
					ranking: '1',
					class: '2班',
					subject: '0'
				},
				{
					name: '何往',
					ranking: '2',
					class: '2班',
					subject: '0'
				}
			],
			stuData1: [
				{
					name: '余鸿建',
					ranking: '1',
					class: '2班',
					subject: '0'
				},
				{
					name: '高诗涵',
					ranking: '2',
					class: '2班',
					subject: '0'
				}
			],
			newStuData1: [
				[
					{
						label: '班级',
						prop: 'banji',
						value: '一班'
					},
					{
						label: '语文1',
						prop: 'yuwen',
						value: '50'
						// children: [
						// 	{
						// 		label: '平均分1',
						// 		prop: 'yuwen-pingjnfen',
						// 		value: '2分'
						// 	},
						// 	{
						// 		label: '平均得分率1',
						// 		prop: 'yuwen-defenjv',
						// 		value: '27%'
						// 	}
						// ]
					},
					{
						label: '数学1',
						prop: 'shuxue',
						value: '52'
					},
					{
						label: '英语1',
						prop: 'English',
						value: '60'
					}
				],
				[
					{
						label: '班级2',
						prop: 'banji',
						value: '二班'
					},
					{
						label: '语文2',
						prop: 'yuwen',
						value: '51'
					},
					{
						name: '数学2',
						prop: 'shuxue',
						value: '54'
					},
					{
						label: '英语2',
						prop: 'English',
						value: '61'
					}
				],
				[
					{
						label: '班级3',
						prop: 'banji',
						value: '三班'
					},
					{
						label: '语文3',
						prop: 'yuwen',
						value: '51.5'
					},
					{
						name: '数学3',
						prop: 'shuxue',
						value: '54.5'
					},
					{
						label: '英语3',
						prop: 'English',
						value: '61.5'
					}
				]
			],
			subjectData: [{ subject: '语文' }, { subject: '数学' }],
			tableOptions: [
				[
					// {
					// 	label: '年级',
					// 	prop: 'nianji',
					// 	value: '5年级'
					// },
					{
						label: '班级',
						prop: 'banji',
						value: '一班'
					},
					{
						label: '语文1',
						prop: 'yuwen',
						children: [
							{
								label: '平均分1',
								prop: 'yuwen-pingjnfen',
								value: '2分'
								// children: [
								// 	{
								// 		label: '平均分1',
								// 		prop: 'yuwen-pingjnfen-pingjnfen',
								// 		value: '1分'
								// 	},
								// 	{
								// 		label: '平均得分率1',
								// 		prop: 'yuwen-pingjnfen-defenjv',
								// 		value: '25%'
								// 	}
								// ]
							},
							{
								label: '平均得分率1',
								prop: 'yuwen-defenjv',
								value: '27%'
							}
						]
					},
					{
						label: '数学1',
						prop: 'shuxue',
						children: [
							{
								label: '平均分1',
								prop: 'shuxue-pingjnfen',
								value: '1分'
							},
							{
								label: '平均得分率1',
								prop: 'shuxue-defenjv',
								value: '28%'
							}
							// {
							// 	label: '众数1',
							// 	prop: 'shuxue-zhongshu',
							// 	value: '88'
							// }
						]
					}
				],
				[
					// {
					// 	label: '年级2',
					// 	prop: 'nianji',
					// 	value: '6年级'
					// },
					{
						label: '班级2',
						prop: 'banji',
						value: '二班'
					},
					{
						label: '语文2',
						prop: 'yuwen',
						children: [
							{
								label: '平均分2',
								prop: 'yuwen-pingjnfen',
								value: '1.1分'
								// children: [
								// 	{
								// 		label: '平均分2',
								// 		prop: 'yuwen-pingjnfen-pingjnfen',
								// 		value: '1分'
								// 	},
								// 	{
								// 		label: '平均得分率2',
								// 		prop: 'yuwen-pingjnfen-defenjv',
								// 		value: '25%'
								// 	}
								// ]
							},
							{
								label: '平均得分率2',
								prop: 'yuwen-defenjv',
								value: '29%'
							}
						]
					},
					{
						name: '数学2',
						prop: 'shuxue',
						children: [
							{
								label: '平均分2',
								prop: 'shuxue-pingjnfen',
								value: '2.1分'
							},
							{
								label: '平均得分率2',
								prop: 'shuxue-defenjv',
								value: '27%'
							},
							{
								label: '众数2',
								prop: 'shuxue-zhongshu',
								value: '88'
							}
						]
					}
				]
			],
			tableData2: [
				{
					class: '全体',
					level: '53.21',
					levelRate: '53.21%',
					level1: '53.22',
					levelRate1: '53.23%'
				},
				{
					class: '2班',
					level: '53.20',
					levelRate: '53.21%',
					level1: '53.24',
					levelRate1: '53.25%'
				}
			],
			tableData1: [
				{
					class: '全体',
					level: '53.21',
					levelRate: '53.21%',
					level1: '53.21',
					levelRate1: '53.21%'
				},
				{
					class: '2班',
					level: '53.21',
					levelRate: '53.21%',
					level1: '53.21',
					levelRate1: '53.21%'
				}
			],
			topTenGradeData: [],
			lastTenGradeData: [],
			goodStudentsData: [],
			improveStudentsData: [],
			examinationStudentsData: [],
			parType: '',
			newParType: '1',
			exceRanking: '',
			improveRanking: '',
			dynamicTableShow: true, // 使得DynamicTable组件重新渲染变量
			exceDesc: '名',
			improDesc: '名',
			flag: false,
			newflag: false,
			RankFlag1: true,
			RankFlag2: false,
			improRankFlag1: true,
			improRankFlag2: false,
			haveData: '',
			RankingRateArr: [],
			excellSudentsData: [],
			ImproveStudentsDataArr: [],
			query: this.$route.query
		}
	},
	mounted() {
		this.getTopRankingStudents() //排名前十的学生
		this.getLastRankingStudents() //排名后十的学生
		// this.getExcellentStudents() //获取优秀学生
		// this.getImproveStudents() //获取待提高学生
		this.getExaminationStudents() //获取联考学生成绩
		// this.getStudentsData()
		this.getExcellStudentsData()
		this.getImproveStudentsData()
	},
	methods: {
		getExaminationStudents() {
			const params = {
				examId: this.query.examId
			}
			this.$post( 'reportApi/selectImportantStudentFromAllStudent', params).then(res => {
				console.log(res)
				this.haveData = res.data.haveData
				this.examinationStudentsData = res.data.data
				// if (res.data.haveData == 1) {
				// 	this.examinationStu dentsData = res.data.data
				// } else if (res.data.haveData == 2) {
				// 	this.examinationStudentsData = []
				// }
			})
		},
		getTopRankingStudents() {
			const params = {
				schoolId: this.query.schoolId,
				examId: this.query.examId,
				type: '1'
				// examSubjectId: ''
			}
			this.$post( 'reportApi/selectImportantStudent', params).then(res => {
				// console.log(res)
				this.topTenGradeData = res.data.data
			})
		},
		getLastRankingStudents() {
			const params = {
				schoolId: this.query.schoolId,
				examId: this.query.examId,
				type: '2'
				// examSubjectId: ''
			}
			this.$post( 'reportApi/selectImportantStudent', params).then(res => {
				this.lastTenGradeData = res.data.data
			})
		},
		//获取学生信息
		getStudentsData() {
			const params = {
				schoolId: this.query.schoolId,
				examId: this.query.examId,
				type: '1',
				// parType: parType,
				parameter: ''
			}
			this.$post( 'reportApi/selectGoodOrBadStudent', params).then(res => {
				this.goodStudentsData = res.data.data
				this.exceRanking = res.data.parameter
			})
		},
		//优秀学生
		getExcellentStudents(parType, level) {
			let sudentsDataObj = {}
			const params = {
				schoolId: this.query.schoolId,
				examId: this.query.examId,
				type: '1', //优秀
				parType: parType,
				// parameter: '30'
				parameter: this.exceRanking
			}
			this.$post( 'reportApi/selectGoodOrBadStudent', params).then(res => {
				this.goodStudentsData = res.data.data
				this.exceRanking = res.data.parameter
				sudentsDataObj.level = level
				// sudentsDataObj.parType = parType
				sudentsDataObj.goodStudentsData = this.goodStudentsData
				sudentsDataObj.exceRanking = this.exceRanking
				this.excellSudentsData.push(sudentsDataObj)
			})
		},
		getExcellStudentsData() {
			this.RankingRateArr = [
				{ parType: '1', level: '名次' },
				{ parType: '2', level: '比例' }
			]
			const params = {
				schoolId: this.query.schoolId,
				examId: this.query.examId,
				type: '1',
				// parType: parType,
				parameter: ''
			}
			this.$post( 'reportApi/selectGoodOrBadStudent', params).then(res => {
				this.exceRanking = res.data.parameter
				this.RankingRateArr.forEach(item => {
					this.getExcellentStudents(item.parType, item.level)
				})
			})
		},
		//待提高学生
		getImproveStudents(parType, level) {
			let sudentsDataObj = {}
			const params = {
				schoolId: this.query.schoolId,
				examId: this.query.examId,
				type: '2', //待提高
				parType: parType,
				// parameter: '30'
				parameter: this.improveRanking
			}
			this.$post( 'reportApi/selectGoodOrBadStudent', params).then(res => {
				this.improveStudentsData = res.data.data
				this.improveRanking = res.data.parameter
				sudentsDataObj.level = level
				sudentsDataObj.improveRanking = this.improveRanking
				sudentsDataObj.improveStudentsData = this.improveStudentsData
				this.ImproveStudentsDataArr.push(sudentsDataObj)
			})
		},
		getImproveStudentsData() {
			this.RankingRateArr = [
				{ level: '名次', parType: '1' },
				{ level: '比例', parType: '2' }
			]
			const params = {
				schoolId: this.query.schoolId,
				examId: this.query.examId,
				type: '2',
				parameter: ''
			}
			this.$post( 'reportApi/selectGoodOrBadStudent', params).then(res => {
				this.improveRanking = res.data.parameter
				this.RankingRateArr.forEach(item => {
					this.getImproveStudents(item.parType, item.level)
				})
			})
		},
		//输入优秀学生名次
		ExceRankingInpt(val) {
			var reg = /^[0-9]*[1-9][0-9]*$/
			if (this.parType == '1') {
				this.flag = false
				if (reg.test(val) || val == '') {
					if (val <= 50) {
						this.flag = false
					} else {
						this.$message('名次不能超过50')
						this.flag = true
					}
				} else {
					this.$message('请输入正整数')
					this.flag = true
				}
			} else if (this.parType == '2') {
				this.flag = false
				if (reg.test(val) || val == '') {
					if (val <= 30) {
						this.flag = false
					} else {
						this.$message('比例不能超过30%')
						this.flag = true
					}
				} else {
					this.$message('请输入正整数')
					this.flag = true
				}
			}
		},
		//输入待提高学生名次
		improveRankingInpt(val) {
			var reg = /^[0-9]*[1-9][0-9]*$/
			if (this.newParType == '1') {
				this.newflag = false
				if (reg.test(val) || val == '') {
					if (val <= 50) {
						this.newflag = false
					} else {
						this.$message('名次不能超过50')
						this.newflag = true
					}
				} else {
					this.$message('请输入正整数')
					this.newflag = true
				}
			} else if (this.newParType == '2') {
				this.newflag = false
				if (reg.test(val) || val == '') {
					if (val <= 30) {
						this.newflag = false
					} else {
						this.$message('比例不能超过30%')
						this.newflag = true
					}
				} else {
					this.$message('请输入正整数')
					this.newflag = true
				}
			}
		},
		exceGradeStatistics() {
			this.getExcellentStudents(this.parType)
		},
		improveGradeStatistics() {
			this.getImproveStudents(this.newParType)
		},
		//名次
		exceRankClick() {
			this.RankFlag1 = true
			this.RankFlag2 = false
			this.exceDesc = '名'
			this.parType = '1'
			if (this.exceRanking > 50) {
				this.flag = true
			} else {
				this.flag = false
			}
			this.getExcellentStudents(this.parType)
		},
		//比例
		exceRateClick() {
			this.RankFlag1 = false
			this.RankFlag2 = true
			this.exceDesc = '%'
			this.parType = '2'
			if (this.exceRanking > 30) {
				this.exceRanking = 30
			}
			if (this.exceRanking > 30) {
				this.flag = true
			} else {
				this.flag = false
			}
			this.getExcellentStudents(this.parType)
		},
		ImproRankClick() {
			this.improRankFlag1 = true
			this.improRankFlag2 = false
			this.improDesc = '名'
			this.newParType = '1'
			if (this.improveRanking > 50) {
				this.newflag = true
			} else {
				this.newflag = false
			}
			this.getImproveStudents(this.newParType)
		},
		ImproRateClick() {
			this.improRankFlag1 = false
			this.improRankFlag2 = true
			this.improDesc = '%'
			this.newParType = '2'
			if (this.improveRanking > 30) {
				this.improveRanking = 30
			}
			if (this.improveRanking > 30) {
				this.newflag = true
			} else {
				this.newflag = false
			}
			this.getImproveStudents(this.newParType)
		}
	}
}
</script>

<style lang="less" scoped>
.current {
	background-color: #009688;
	color: #fff;
	border: 1px solid #009688;
}
.key-students {
	height: auto;
	margin: 10px 0px;
	padding: 30px;
	border: 1px solid #ebeef5;
	background-color: #fff;
	color: #303133;
	-webkit-transition: 0.3s;
	transition: 0.3s;
	border-radius: 4px;
	overflow: hidden;
	.key-students-cont {
		height: auto;
		// background-color: wheat;
		.keyStudents-title {
			margin-bottom: 10px;
			> span {
				font-weight: bold;
				font-size: 18px;
				color: #333;
				margin-right: 20px;
			}
		}
		.topTen-desc,
		.lastten-desc {
			display: flex;
			height: 40px;
			margin-bottom: 5px;
			align-items: center;
			> span {
				font-size: 14px;
				flex-grow: 1;
			}
		}
		.topten-table,
		.lastten-table {
			height: auto;
			// background-color: skyblue;
			/deep/.cell {
				text-align: center;
			}
		}
		.excellent-students,
		.improved-students {
			height: auto;
			margin-top: 30px;
			// background-color: slateblue;
			.excestu-title {
				display: flex;
				height: 45px;
				align-items: center;
				margin-bottom: 5px;
				.excestu-title-cont {
					flex-grow: 1;
					display: flex;
					height: 45px;
					align-items: center;
					justify-content: space-between;
					margin-right: 30px;
					.Ranking-rate {
						width: 121px;
						height: 45px;
						// border: 1px solid skyblue;
						display: flex;
						align-items: center;
						justify-content: center;
						/deep/.el-button + .el-button {
							margin-left: 0px;
						}
						/deep/ .el-button:hover {
							color: #fff;
							background-color: #009688;
						}
					}
					.top-grade {
						width: 113px;
						height: 45px;
						// border: 1px solid tomato;
						display: flex;
						align-items: center;
						/deep/.el-input {
							width: 40%;
							margin: 0 3px;
						}
					}
				}
				> div:nth-child(2) {
					/deep/.el-button--info {
						background-color: #009688;
					}
				}
			}
			.excestu-table {
				height: auto;
				/deep/.cell {
					text-align: center;
				}
			}
		}
		.improved-students {
			margin-top: 30px;
		}
	}
	&:hover {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}
}
</style>
